import { QueovalBase } from '../global';


export class DashBase extends QueovalBase {
  Context: string;
}

export class DashboardModel extends DashBase {
  public IdRole: string;
  public IdContext: string;
  public DashboardItemList: Array<DashboardItem>;
}

export class DashboardCollectionModel {
  Cols_IDA: string;
  Ident: string;
  IdcptIDA: string;
  Rows_IDA: string;
  ImageIDA: string;
  TycptIDA: string;
  TitleIDA: string;
  Draggable: boolean;
}

export class GraphiqueModels extends QueovalBase {
  public Graphiques: GraphiqueModel[];
}

export class GraphiqueModel {
  public Key: string;
  public ChartType: string;
  public Title: string;
  public ChartLabel: string[];
  public ChartData: string;
}

export class Graphique {
  public Key: string;
  public ChartType: string;
  public Title: string;
  public ChartLabel: string[];
  public ChartData: Datas;

  constructor(key: string, chartType: string, title: string, chartLabel: string[], chartData: Datas) {
    this.Key = key;
    this.ChartType = chartType;
    this.Title = title;
    this.ChartLabel = chartLabel;
    this.ChartData = chartData;
  }
}

export class Datas {
  public Data: number[];
  public Labels: string;
}

export class DashboardInput {
  id: string;
  idCpt: string;
  title: string;
  size: { height: number, width: number };
}

export class DashboardItem {
  id: string;
  idComponent: string;
  title: string;
  inputs: DashboardInput;
  selector: string;
  cols: number;
  rows: number;
  x: number;
  y: number;
  height: number;
  img: string;
  isVisible: boolean;
}

export class ElearningDashBoardModel extends QueovalBase {
  public Cycles: Array<CycleElearning>;
  public Apprenants: Array<ApprenantElearning>;
}

export class CycleElearning {
  public Id: string;
  public Nom: string;
  public Chapitres: Array<ChapitreElearning>;
  public Time: number;
  public Progression: number;
  public chapterEnd: number;
  public chapterLength: number;
  public isAffected: boolean;
}

export class ChapitreElearning {
  public Id: string;
  public Label: string;
  public Progression: number;
  public time: number;
  public NumberModule: number;
  public ModuleValidate: number;
}

export class ApprenantElearning {
  public Id: string;
  public Nom: string;
  public Prenom: string;
}
